(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-this-week"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.new-this-week');
    sections.forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('.new-this-week-tab'));
      const panels = Array.from(root.querySelectorAll('.new-this-week-products'));
      const viewAllLink = root.querySelector('[data-view-all-link]');

      function updateViewAllUrl(tabIndex) {
        let activePanelUrl = '';
        panels.forEach((panel) => {
          const isActive = panel.dataset.tabContent === String(tabIndex);
          panel.classList.toggle('active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (isActive) {
            activePanelUrl = panel.dataset.viewAllUrl || '';
          }
        });

        if (viewAllLink) {
          if (activePanelUrl) {
            viewAllLink.setAttribute('href', activePanelUrl);
          } else {
            viewAllLink.removeAttribute('href');
          }
        }
      }

      function switchTab(tabIndex) {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.tab === String(tabIndex);
          tab.classList.toggle('active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        updateViewAllUrl(tabIndex);
      }

      tabs.forEach((tab, index) => {
        if (index === 0 && tab.classList.contains('active')) {
          tab.setAttribute('tabindex', '0');
        } else if (!tab.hasAttribute('tabindex')) {
          tab.setAttribute('tabindex', tab.classList.contains('active') ? '0' : '-1');
        }

        tab.addEventListener('click', () => {
          switchTab(tab.dataset.tab);
          tab.focus();
        });

        tab.addEventListener('keydown', (event) => {
          const currentIndex = tabs.indexOf(tab);
          let newIndex = currentIndex;

          if (event.key === 'ArrowRight') {
            newIndex = (currentIndex + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft') {
            newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            newIndex = 0;
          } else if (event.key === 'End') {
            newIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          const newTab = tabs[newIndex];
          switchTab(newTab.dataset.tab);
          newTab.focus();
        });
      });

      const initialTab = root.querySelector('.new-this-week-tab.active') || tabs[0];
      if (initialTab) {
        switchTab(initialTab.dataset.tab);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
